import { render } from "./Notifiche.vue?vue&type=template&id=aa01b5a0&scoped=true"
import script from "./Notifiche.vue?vue&type=script&lang=js"
export * from "./Notifiche.vue?vue&type=script&lang=js"

import "./Notifiche.vue?vue&type=style&index=0&id=aa01b5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa01b5a0"]])

export default __exports__